import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cardContainer: {
    width: "100%",
    backgroundColor: theme.palette.secondary.main + "78",
    padding: "16px",
    borderRadius: 4
  },

  cardHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',

    '& h3': {
      fontSize: 16,
      fontWeight: 400,
      color: theme.palette.primary.main
    }
  },

  cardHeaderHourInfoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 4,
  },

  cardHeaderDateContainer: {
    marginBottom: 16,
    paddingTop: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },

  cardSpanText: {
    color: theme.palette.primary.main
  },

  cardParagraphText: {
    color: '#000',
    fontFamily: 'Roboto'

  },

  cardSpanDateText: {
    fontSize: 12,
    color: '#968C8C'
  },

  cardTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  }

}))
